import React from "react";
import styles from "./index.module.css"
import logo from "../../assets/images/icons/LogoSSD.svg"
import {useAuthStore} from "../../store/AuthStore";
import {shallow} from "zustand/shallow";
import {useForm} from "react-hook-form";
import * as API from "../../constants/urls";
import axios from "axios";
import Cookies from "js-cookie";


const Login = () =>{
    const [setAuthorized] = useAuthStore(s => [s.setAuthorized], shallow);
    const { register, handleSubmit, formState: { errors } } = useForm();

    const handleLogin = async (data) => {
        const response = await axios.post(`${API.BASE_URL}${API.LOGIN}`, data);
        return response;
    };

    const onSubmit = (data) => {
        handleLogin(data)
            .then((response) => {
                const token = response.data.data.token
                Cookies.set('token', token)
                setAuthorized(true)
            })
            .catch((error) => {
                console.log(error);
            });
    };

    return(
        <div className={styles.login}>
            <div className={styles.login_top}>
                <img src={logo} alt='logo'/>
            </div>
            <div className={styles.login_form}>
                <h2 className={styles.login_title}>Вход в аккаунт</h2>
                <form
                    onSubmit={handleSubmit(onSubmit)}
                    className={styles.login_form_box}
                >
                    <label className={styles.login_label}>
                        <span>Логин или email</span>
                        <input
                            type="text"
                            id="username"
                            autoComplete="off"
                            {...register('username', {required : true})}
                        />
                    </label>
                    <label className={styles.login_label}>
                        <span>Пароль</span>
                        <input
                            type="password"
                            id="password"
                            {...register('password', {required : true})}
                        />
                    </label>
                    {errors.password && <p>This field is required</p>}
                    {/*<p ref={errRef} className={errMsg ? 'errmsg' : 'offscreen'} aria-live='assertive'/>*/}
                    <div className={styles.login_password}>
                        <label className={styles.checkbox_label}>
                            <input type="checkbox"/>
                            <span className={styles.checkmark}/>
                            Запомнить меня
                        </label>
                        <p className={styles.forgot_password}> Забыли пароль?</p>
                    </div>
                    <button className={styles.login_submit} onClick={handleSubmit(onSubmit)}>Вход в аккаунт</button>
                </form>
            </div>
        </div>
    )
}
export default Login;